import { Button } from '@material-ui/core';
import React from 'react';
import { ButtonStack } from '../../../../elements/ButtonStack/buttonStack';
import { ContactPhone, ContactPhoneHref } from '../../../../elements/ContactPhone/contactPhoneNumber';
import { Phone } from '../../../../elements/PantheraIcon';
import { BubbleSmsFilled } from '../../../../elements/PantheraIcon/BubbleSmsFilled';
import { EmailSolid } from '../../../../elements/PantheraIcon/EmailSolid';
import useStyles from './contactButtons.styles';

export type ContactButtonProps = {
	email?: string;
	phone?: {
		href: string;
		number: string;
	};
};

export const ContactButtons: React.FC<ContactButtonProps> = ({ email, phone, children }) => {
	const styles = useStyles();
	return (
		<ButtonStack className={styles.buttonStack}>
			<a href={ContactPhoneHref()} style={{ textDecoration: 'none' }}>
				<Button color="secondary" fullWidth size="large" variant="contained">
					<Phone className={styles.buttonIcon} /> Call 1300 665 274
				</Button>
			</a>
			{email && (
				<a href={`mailto:${email}`} style={{ textDecoration: 'none' }}>
					<Button color="secondary" fullWidth size="large" variant="contained">
						<EmailSolid className={styles.buttonIcon} /> Email
					</Button>
				</a>
			)}
			{children}
		</ButtonStack>
	);
};
